import './Settings.scss';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getLocationSettings } from 'actions/provider';
import { getUserSettings } from 'actions/user';
import AppointmentDrawerLoader from 'organisms/Loaders/AppointmentDrawerLoader';
import { isEmpty } from 'util';

import MaxBookings from './MaxBookings';

export default function SettingsDrawer() {
  const dispatch = useDispatch();
  const { uuid } = useSelector((state) => state.ui.selectedGroomer);
  const settings = useSelector((state) => state.entitySettings);

  useEffect(() => {
    let action = getUserSettings;
    if (uuid === 'all') {
      action = getLocationSettings;
    }
    // uuid will be irrelevant if fetching local data
    dispatch(action({ uuid }));
  }, []);

  if (isEmpty(settings))
    return (
      <div className="appointment-drawer">
        <AppointmentDrawerLoader />
      </div>
    );

  return (
    <div className="appointment-drawer flex-column align-end">
      <div className="w-100">
        <div className="flex-column mb-25">
          <h2 className="f26 mb-25">Availability settings</h2>
          <MaxBookings maxConcurrency={settings.maxConcurrency} />
        </div>
      </div>
    </div>
  );
}
